export const environment = {
  production: true,
  apiBaseUrl: 'https://dev.api.mycodi.io/admin/',
  tokenKey: 'admin_access_token',
  adminDataKey: 'admin_data',
  sessionTimeout: 3600000,
};
